import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-delete.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const DeleteIcon = createSvgIcon(<Icon />, 'DeleteIcon');
